import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "inputRef", "size", "onChange", "width", "minWidth", "maxWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { InputWrapper } from '../../../internal/components/InputWrapper/InputWrapper';
import { InputWrapperInput } from '../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../internal/components/FocusObserver/FocusObserver';
import { FocusSource } from '../../../internal/types';
import { jsx as _jsx } from "react/jsx-runtime";
const InputComponent = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
  const {
      type = 'text',
      loading,
      disabled,
      invalid,
      inline,
      leftAdornment,
      rightAdornment,
      inputRef,
      size,
      onChange,
      width,
      minWidth,
      maxWidth
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [focus, setFocus] = React.useState({
    focused: false,
    source: FocusSource.mouse
  });
  const handleChange = e => {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
  };
  const handleFocus = (focused, source) => {
    setFocus({
      focused,
      source
    });
  };
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    focused: focus.focused,
    focusSource: focus.source,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: leftAdornment,
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(InputWrapperInput, _objectSpread(_objectSpread({}, rest), {}, {
        type: type,
        ref: inputRef,
        disabled: disabled,
        onChange: handleChange
      }))
    })
  });
});
export const Input = /*#__PURE__*/React.memo(InputComponent);